export const UPDATE = 'UPDATE'
export const CREATE = 'CREATE'
export const DELETE = 'DELETE'
export const SELECT = 'SELECT'

export const LOAD = '_LOAD'
export const SUCCESS = '_SUCCESS'
export const FAILED = '_FAILED'
